export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: { input: any; output: any; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

export type Activities = {
  __typename?: 'Activities';
  hasMore: Scalars['Boolean']['output'];
  items: Array<Activity>;
};

export type Activity = {
  __typename?: 'Activity';
  actor?: Maybe<ActivityActor>;
  category: ActivityCategory;
  createdAt: Scalars['DateTime']['output'];
  details: Array<ActivityDetail>;
  fromStage?: Maybe<PostStage>;
  id: Scalars['String']['output'];
  stage?: Maybe<PostStage>;
  type: ActivityType;
};

export type ActivityActor = {
  __typename?: 'ActivityActor';
  color?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isGuest: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
};

export enum ActivityCategory {
  Post = 'POST'
}

export type ActivityDetail = {
  __typename?: 'ActivityDetail';
  date?: Maybe<Scalars['DateTime']['output']>;
  kind: ActivityDetailKind;
  labels?: Maybe<Array<ActivityLabel>>;
  users?: Maybe<Array<Scalars['String']['output']>>;
};

export enum ActivityDetailKind {
  PostAssignees = 'POST_ASSIGNEES',
  PostBriefing = 'POST_BRIEFING',
  PostBudget = 'POST_BUDGET',
  PostContent = 'POST_CONTENT',
  PostLabels = 'POST_LABELS',
  PostLinks = 'POST_LINKS',
  PostMedia = 'POST_MEDIA',
  PostNetwork = 'POST_NETWORK',
  PostSchedule = 'POST_SCHEDULE'
}

export type ActivityLabel = {
  __typename?: 'ActivityLabel';
  color: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum ActivityType {
  PostArchived = 'POST_ARCHIVED',
  PostAssigned = 'POST_ASSIGNED',
  PostCreated = 'POST_CREATED',
  PostDuplicated = 'POST_DUPLICATED',
  PostEdited = 'POST_EDITED',
  PostLabelsChanged = 'POST_LABELS_CHANGED',
  PostScheduled = 'POST_SCHEDULED',
  PostStageChanged = 'POST_STAGE_CHANGED',
  PostUnscheduled = 'POST_UNSCHEDULED'
}

export type AndieChatChunk = {
  __typename?: 'AndieChatChunk';
  data: Scalars['JSON']['output'];
  done: Scalars['Boolean']['output'];
  streamId: Scalars['String']['output'];
};

export type AndieChatMessagesResponse = {
  __typename?: 'AndieChatMessagesResponse';
  messages: Scalars['JSON']['output'];
  plan?: Maybe<Scalars['JSON']['output']>;
  thread: AndieChatThread;
};

export type AndieChatThread = {
  __typename?: 'AndieChatThread';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AndieChatThreadsResponse = {
  __typename?: 'AndieChatThreadsResponse';
  threads: Array<AndieChatThread>;
};

export type AndieSuggestion = {
  __typename?: 'AndieSuggestion';
  fullMessage: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type AndieSuggestionsMessageInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  parts?: InputMaybe<Array<AndieSuggestionsMessagePartInput>>;
  role: Scalars['String']['input'];
};

export type AndieSuggestionsMessagePartInput = {
  text?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type AndieSuggestionsResponse = {
  __typename?: 'AndieSuggestionsResponse';
  suggestions: Array<AndieSuggestion>;
};

export type AndieUsageStatus = {
  __typename?: 'AndieUsageStatus';
  blocked: Scalars['Boolean']['output'];
  briefingsGenerated: Scalars['Int']['output'];
  contentPlansGenerated: Scalars['Int']['output'];
  creditLimit: Scalars['Int']['output'];
  imagesGenerated: Scalars['Int']['output'];
  insightsAnalyzed: Scalars['Int']['output'];
  percentageUsed: Scalars['Float']['output'];
  periodResetsAt: Scalars['DateTime']['output'];
  remainingCredits: Scalars['Float']['output'];
  usedCredits: Scalars['Float']['output'];
};

export type ApiClient = {
  __typename?: 'ApiClient';
  id: Scalars['String']['output'];
  lastKeySlotUsed?: Maybe<ApiClientKeySlot>;
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  primaryKey?: Maybe<Scalars['String']['output']>;
  primaryKeyGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  secondaryKey?: Maybe<Scalars['String']['output']>;
  secondaryKeyGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Key slot type for API client */
export enum ApiClientKeySlot {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

export type AuthPublicToken = {
  __typename?: 'AuthPublicToken';
  expiresAt: Scalars['DateTime']['output'];
  token: Scalars['String']['output'];
};

export type Budget = {
  __typename?: 'Budget';
  currency: Currency;
  value: Scalars['Float']['output'];
};

export type CompareTo = {
  __typename?: 'CompareTo';
  code: CompareToCode;
  id: Scalars['String']['output'];
  nameKey: Scalars['String']['output'];
};

export enum CompareToCode {
  PreviousMonth = 'PREVIOUS_MONTH',
  PreviousPeriod = 'PREVIOUS_PERIOD',
  PreviousYear = 'PREVIOUS_YEAR'
}

export type CountUnreadNotifications = {
  __typename?: 'CountUnreadNotifications';
  tab: NotificationTab;
  value: Scalars['Int']['output'];
};

export type Country = {
  __typename?: 'Country';
  code: Scalars['String']['output'];
  id: Scalars['String']['output'];
  nameKey: Scalars['String']['output'];
};

export type Currency = {
  __typename?: 'Currency';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

export type Dash = {
  __typename?: 'Dash';
  brandName?: Maybe<Scalars['String']['output']>;
  brandPicture?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<Array<InsightsCategory>>;
  compareTo?: Maybe<CompareTo>;
  created?: Maybe<User>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDemo: Scalars['Boolean']['output'];
  isFavorite: Scalars['Boolean']['output'];
  isPopular: Scalars['Boolean']['output'];
  labels?: Maybe<Array<Label>>;
  name: Scalars['String']['output'];
  numberOfWidgets: Scalars['Int']['output'];
  period?: Maybe<Period>;
  profiles?: Maybe<Array<DashSourceProfile>>;
  scheduleDeliveryEmails?: Maybe<Array<Scalars['String']['output']>>;
  scheduleExportType?: Maybe<ExportReqType>;
  scheduleFrequency?: Maybe<ScheduleFrequency>;
  scheduleMonthlyDay?: Maybe<Scalars['Int']['output']>;
  scheduleTime?: Maybe<Scalars['DateTime']['output']>;
  scheduleWeekDay?: Maybe<ScheduleWeekDay>;
  shareExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  shareRef?: Maybe<Scalars['String']['output']>;
  since?: Maybe<Scalars['DateTime']['output']>;
  sources?: Maybe<Array<DashSource>>;
  theme?: Maybe<Theme>;
  until?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  viewType: DashViewType;
};

export type DashFilters = {
  __typename?: 'DashFilters';
  compareTo?: Maybe<CompareTo>;
  labels?: Maybe<Array<Label>>;
  period?: Maybe<Period>;
  profiles?: Maybe<Array<DashSourceProfile>>;
  since?: Maybe<Scalars['DateTime']['output']>;
  until?: Maybe<Scalars['DateTime']['output']>;
};

export enum DashListType {
  Demos = 'DEMOS',
  Mine = 'MINE',
  Suggested = 'SUGGESTED',
  Templates = 'TEMPLATES'
}

export type DashOrderBy = {
  field: DashOrderByField;
  sort?: InputMaybe<SortOrder>;
};

export enum DashOrderByField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME'
}

export type DashProfileArgs = {
  dashSourceId: Scalars['String']['input'];
  profileId: Scalars['String']['input'];
};

export type DashSource = {
  __typename?: 'DashSource';
  code: DashSourceCode;
  group: DashSourceGroup;
  id: Scalars['String']['output'];
  nameKey: Scalars['String']['output'];
};

export enum DashSourceCode {
  Blogger = 'BLOGGER',
  Facebook = 'FACEBOOK',
  FacebookPublic = 'FACEBOOK_PUBLIC',
  GoogleMyBusiness = 'GOOGLE_MY_BUSINESS',
  Instagram = 'INSTAGRAM',
  InstagramPublic = 'INSTAGRAM_PUBLIC',
  InstagramV2 = 'INSTAGRAM_V2',
  Linkedin = 'LINKEDIN',
  MetaAds = 'META_ADS',
  Pinterest = 'PINTEREST',
  Threads = 'THREADS',
  Tiktok = 'TIKTOK',
  Tumblr = 'TUMBLR',
  Twitter = 'TWITTER',
  Wordpress = 'WORDPRESS',
  WordpressOrg = 'WORDPRESS_ORG',
  Youtube = 'YOUTUBE'
}

export enum DashSourceGroup {
  Competitors = 'COMPETITORS',
  Profiles = 'PROFILES'
}

export type DashSourceProfile = {
  __typename?: 'DashSourceProfile';
  dashSource: DashSource;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  picture?: Maybe<Scalars['String']['output']>;
  status: DashSourceProfileStatus;
  tokenExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export enum DashSourceProfileStatus {
  Active = 'ACTIVE',
  Connected = 'CONNECTED',
  Disconnected = 'DISCONNECTED',
  Expiring = 'EXPIRING',
  NotAvailable = 'NOT_AVAILABLE',
  Paused = 'PAUSED',
  Suspended = 'SUSPENDED'
}

export enum DashViewType {
  Dashboard = 'DASHBOARD',
  Report = 'REPORT'
}

export type DashboardData = {
  __typename?: 'DashboardData';
  competitorsCount: Scalars['Int']['output'];
  postsPublished30Days: Scalars['Int']['output'];
  profilesCount: Scalars['Int']['output'];
};

export type DashboardGetStarted = {
  __typename?: 'DashboardGetStarted';
  dashboardCreated: Scalars['Boolean']['output'];
  postCreated: Scalars['Boolean']['output'];
  profileConnected: Scalars['Boolean']['output'];
};

export enum ExportReqType {
  DashCsv = 'DASH_CSV',
  DashPdf = 'DASH_PDF'
}

export enum FileFormat {
  Image = 'IMAGE',
  Undefined = 'UNDEFINED',
  Video = 'VIDEO'
}

export type FirstComment = {
  plainText: Scalars['String']['input'];
  richText: Scalars['JSON']['input'];
};

export type FormulaMetric = {
  __typename?: 'FormulaMetric';
  breakdownKeys: Array<Scalars['String']['output']>;
  letter: Scalars['String']['output'];
  metric: Metric;
};

export type Group = {
  __typename?: 'Group';
  color: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  publicId: Scalars['Int']['output'];
};

export enum GuestArea {
  PostsView = 'POSTS_VIEW'
}

export enum GuestStatus {
  Active = 'ACTIVE',
  Invited = 'INVITED',
  Revoked = 'REVOKED'
}

export type InsightsCategory = {
  __typename?: 'InsightsCategory';
  color: Scalars['String']['output'];
  id: Scalars['String']['output'];
  nameKey: Scalars['String']['output'];
};

export type IntegrationQuota = {
  __typename?: 'IntegrationQuota';
  blocked: Scalars['Boolean']['output'];
  isFreeTier: Scalars['Boolean']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  remaining?: Maybe<Scalars['Int']['output']>;
  used: Scalars['Int']['output'];
};

export type IntegrationUsageDay = {
  __typename?: 'IntegrationUsageDay';
  api: Scalars['Int']['output'];
  day: Scalars['String']['output'];
  mcp: Scalars['Int']['output'];
};

export type IntegrationUsageStatus = {
  __typename?: 'IntegrationUsageStatus';
  api: IntegrationQuota;
  dailyUsage: Array<IntegrationUsageDay>;
  mcp: IntegrationQuota;
  periodResetsAt: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  periodStartDay: Scalars['String']['output'];
};

export type Invoice = {
  __typename?: 'Invoice';
  date: Scalars['String']['output'];
  docNumber: Scalars['String']['output'];
  id: Scalars['String']['output'];
  value: InvoiceValue;
};

export type InvoiceValue = {
  __typename?: 'InvoiceValue';
  amount: Scalars['Float']['output'];
  currency: Currency;
};

export type InvoicingInfo = {
  __typename?: 'InvoicingInfo';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country: Country;
  isPerson: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<Scalars['String']['output']>;
};

export type Label = {
  __typename?: 'Label';
  color: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Language = {
  __typename?: 'Language';
  code: Scalars['String']['output'];
  id: Scalars['String']['output'];
  nameKey: Scalars['String']['output'];
};

export type LinkScrape = {
  __typename?: 'LinkScrape';
  data?: Maybe<LinkScrapeData>;
  isValid: Scalars['Boolean']['output'];
  issue?: Maybe<Scalars['String']['output']>;
};

export type LinkScrapeData = {
  __typename?: 'LinkScrapeData';
  description?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<LinkScrapeImages>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type LinkScrapeImages = {
  __typename?: 'LinkScrapeImages';
  url: Scalars['String']['output'];
};

export type MediaLib = {
  __typename?: 'MediaLib';
  id: Scalars['String']['output'];
  isCustomPreview: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  preview: Scalars['String']['output'];
  previewSpecs?: Maybe<MediaLibSpecs>;
  previewStatus?: Maybe<MediaLibStatus>;
  specs?: Maybe<MediaLibSpecs>;
  status: MediaLibStatus;
  type?: Maybe<FileFormat>;
};

export type MediaLibSpecs = {
  __typename?: 'MediaLibSpecs';
  duration?: Maybe<Scalars['Float']['output']>;
  fileSizeBytes?: Maybe<Scalars['BigInt']['output']>;
  fps?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export enum MediaLibStatus {
  Archived = 'ARCHIVED',
  Error = 'ERROR',
  Processing = 'PROCESSING',
  Success = 'SUCCESS',
  Uploading = 'UPLOADING'
}

export type Metric = {
  __typename?: 'Metric';
  alerts?: Maybe<Array<MetricAlert>>;
  code: Scalars['String']['output'];
  codeGroup: Scalars['String']['output'];
  deprecatedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<MetricEntity>;
  formula?: Maybe<Scalars['String']['output']>;
  formulaMetrics?: Maybe<Array<FormulaMetric>>;
  groupByOp?: Maybe<MetricGroupByOp>;
  hasLabels: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isExportable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sources?: Maybe<Array<DashSource>>;
  status: Scalars['Int']['output'];
  type: MetricType;
  unit?: Maybe<Scalars['String']['output']>;
};

export type MetricAlert = {
  __typename?: 'MetricAlert';
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: MetricAlertStatus;
  type: MetricAlertType;
  url?: Maybe<Scalars['String']['output']>;
};

export enum MetricAlertStatus {
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING'
}

export enum MetricAlertType {
  Deprecation = 'DEPRECATION',
  Incident = 'INCIDENT'
}

export enum MetricEntity {
  Daily = 'DAILY',
  Posts = 'POSTS'
}

export enum MetricGroupByKey {
  AutoBreakdown = 'AUTO_BREAKDOWN',
  Date = 'DATE',
  DateWeekHour = 'DATE_WEEK_HOUR',
  Metric = 'METRIC',
  Post = 'POST',
  PostFormat = 'POST_FORMAT',
  PostHashtags = 'POST_HASHTAGS',
  PostLabels = 'POST_LABELS',
  PostType = 'POST_TYPE',
  Profile = 'PROFILE',
  Total = 'TOTAL'
}

export enum MetricGroupByOp {
  Avg = 'AVG',
  LastValue = 'LAST_VALUE',
  Sum = 'SUM'
}

export enum MetricType {
  Breakdown = 'BREAKDOWN',
  Date = 'DATE',
  DateWeekHour = 'DATE_WEEK_HOUR',
  Image = 'IMAGE',
  Number = 'NUMBER',
  String = 'STRING',
  Url = 'URL'
}

export type Mutation = {
  __typename?: 'Mutation';
  addBlankWidget: Widget;
  addCompetitors: Scalars['Boolean']['output'];
  addInsightWidget: Array<Widget>;
  addMediaLibPreview: MediaLib;
  addNoteWidget: Widget;
  andieSuggestions: AndieSuggestionsResponse;
  approvePost: Post;
  cancelPostClientReview: Post;
  cancelSubscription: Scalars['Boolean']['output'];
  changePaymentMethod: Scalars['String']['output'];
  clearAllNotifications: Scalars['Boolean']['output'];
  clearNotification: Scalars['Boolean']['output'];
  clientApprovePost: Post;
  clientRequestPostRevision: Post;
  configurePlan: Scalars['String']['output'];
  confirmUserChangeEmail: Scalars['Boolean']['output'];
  createApiClient: ApiClient;
  createDash: Dash;
  createDashShareToken: AuthPublicToken;
  createGroup: Group;
  createLabel: Label;
  createMediaLib: MediaLib;
  createPost: Post;
  createPostsView: PostsView;
  createPostsViewShareToken: AuthPublicToken;
  deleteAccount: Scalars['Boolean']['output'];
  deleteAndieChatThread: Scalars['Boolean']['output'];
  deleteCompetitors: Array<Scalars['String']['output']>;
  deleteDash: Scalars['Boolean']['output'];
  deleteDashWidget: Widget;
  deleteGroup: Scalars['Boolean']['output'];
  deleteInvoicingInfo: Scalars['Boolean']['output'];
  deleteMediaLib: MediaLib;
  deletePost: Post;
  deletePostMessage: PostMessage;
  deletePostsView: PostsView;
  deleteUserPicture: Scalars['Boolean']['output'];
  deleteWorkspacePicture: Scalars['Boolean']['output'];
  downloadInvoice: Scalars['String']['output'];
  duplicateDash: Dash;
  duplicatePost: Post;
  duplicateWidget: Widget;
  editDash: Dash;
  editDashViewType: Dash;
  editDashWidgetsPosition: Array<Widget>;
  editInsightWidget: Widget;
  editNoteWidgetText: Widget;
  editPostMessage: PostMessage;
  exportDashCsv: Scalars['Boolean']['output'];
  exportDashPdf: Scalars['Boolean']['output'];
  exportUserData: Scalars['String']['output'];
  guestApprovePost: Post;
  guestDeletePostMessage: PostMessage;
  guestEditPostMessage: PostMessage;
  guestRequestPostRevision: Post;
  guestSendPostMessage: PostMessage;
  guestTogglePostMessageReaction: PostMessage;
  inviteWorkspaceGuest: WorkspaceGuestWithToken;
  logout: Scalars['Boolean']['output'];
  moveOnboardingToPost: Onboarding;
  readAllNotifications: Scalars['Boolean']['output'];
  readNotification: Scalars['Boolean']['output'];
  rejectPost: Post;
  removeMediaLibPreview: MediaLib;
  removeOverQuotaItems: Array<PlanLimitsList>;
  requestUserChangeEmail: Scalars['Boolean']['output'];
  resendRegisterConfirmEmail: Scalars['Boolean']['output'];
  resendWorkspaceGuestInvite: WorkspaceGuestWithToken;
  revokeWorkspaceGuest: WorkspaceGuest;
  rotateApiClient: ApiClient;
  saveDashFilters: DashFilters;
  schedulePost: Post;
  sendPostMessage: PostMessage;
  sendPostToClientReview: Post;
  setGroupProfiles: Group;
  setUserNotificationChannel: Scalars['Boolean']['output'];
  subscribe: Subscribe;
  switchWorkspace: Workspace;
  teamReviewPost: Post;
  toggleDashShareToken?: Maybe<AuthPublicToken>;
  toggleFavoriteDash: Array<Dash>;
  toggleFavoriteWidget: Array<Widget>;
  togglePinPostsView: PostsView;
  togglePostMessageReaction: PostMessage;
  togglePostsViewShareToken?: Maybe<AuthPublicToken>;
  unclearNotification: Scalars['Boolean']['output'];
  unreadNotification: Scalars['Boolean']['output'];
  unschedulePost: Post;
  updateAccountTimezone: User;
  updateAndieChatThreadTitle: AndieChatThread;
  updateBillingEmail?: Maybe<Scalars['String']['output']>;
  updateGroup: Group;
  updateInvoicingInfo: InvoicingInfo;
  updateLanguage: User;
  updatePost: Post;
  updatePostsView: PostsView;
  updateUserInfo: User;
  updateUserPhoneNumber: User;
  updateUserPicture: Scalars['Boolean']['output'];
  updateWorkspaceInfo: Scalars['Boolean']['output'];
  updateWorkspaceLanguage: Scalars['Boolean']['output'];
  updateWorkspacePicture: Scalars['Boolean']['output'];
  updateWorkspaceSettings: WorkspaceSettings;
  updateWorkspaceTimezone: Workspace;
  userResourceDismissDismiss: UserResourceDismissResource;
  userResourceDismissRevertDismiss: UserResourceDismissResource;
};


export type MutationAddBlankWidgetArgs = {
  dashId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  periodId: Scalars['String']['input'];
  profiles?: InputMaybe<Array<DashProfileArgs>>;
  widgetMetrics: Array<WidgetMetricInput>;
  widgetTypeId: Scalars['String']['input'];
};


export type MutationAddCompetitorsArgs = {
  netProfileIds: Array<Scalars['String']['input']>;
};


export type MutationAddInsightWidgetArgs = {
  dashId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  widgetsIds: Array<Scalars['String']['input']>;
};


export type MutationAddMediaLibPreviewArgs = {
  mediaLibId: Scalars['String']['input'];
  previewPath: Scalars['String']['input'];
  previewSpecs: PreviewSpecs;
};


export type MutationAddNoteWidgetArgs = {
  dashId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAndieSuggestionsArgs = {
  chatId?: InputMaybe<Scalars['String']['input']>;
  messages: Array<AndieSuggestionsMessageInput>;
  threadId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationApprovePostArgs = {
  postId: Scalars['String']['input'];
};


export type MutationCancelPostClientReviewArgs = {
  postId: Scalars['String']['input'];
};


export type MutationClearAllNotificationsArgs = {
  tab?: NotificationTab;
};


export type MutationClearNotificationArgs = {
  group?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationClientApprovePostArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  postId: Scalars['String']['input'];
};


export type MutationClientRequestPostRevisionArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  postId: Scalars['String']['input'];
};


export type MutationConfigurePlanArgs = {
  features: Array<PlanFeatureInput>;
  interval: PlanPriceInterval;
  planId: Scalars['String']['input'];
  totalPrice: Scalars['Float']['input'];
};


export type MutationConfirmUserChangeEmailArgs = {
  id: Scalars['String']['input'];
};


export type MutationCreateDashArgs = {
  brandName?: InputMaybe<Scalars['String']['input']>;
  brandPicture?: InputMaybe<Scalars['String']['input']>;
  categoriesIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dashId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  profiles: Array<DashProfileArgs>;
  scheduleDeliveryEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduleExportType?: InputMaybe<ExportReqType>;
  scheduleFrequency?: InputMaybe<ScheduleFrequency>;
  scheduleMonthlyDay?: InputMaybe<Scalars['Int']['input']>;
  scheduleTime?: InputMaybe<Scalars['String']['input']>;
  scheduleWeekDay?: InputMaybe<ScheduleWeekDay>;
  themeId: Scalars['String']['input'];
  viewType?: InputMaybe<DashViewType>;
};


export type MutationCreateDashShareTokenArgs = {
  dashId: Scalars['String']['input'];
};


export type MutationCreateGroupArgs = {
  color?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationCreateLabelArgs = {
  color?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationCreateMediaLibArgs = {
  mediaPath: Scalars['String']['input'];
  name: Scalars['String']['input'];
  specs: Specs;
};


export type MutationCreatePostArgs = {
  briefing?: InputMaybe<PostBriefingArgs>;
  captions?: InputMaybe<Array<PostCaptionArgs>>;
  facebook?: InputMaybe<PostFacebookArgs>;
  googleMyBusiness?: InputMaybe<PostGoogleMyBusinessArgs>;
  instagram?: InputMaybe<PostInstagramArgs>;
  instagramV2?: InputMaybe<PostInstagramV2Args>;
  labelsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  linkedIn?: InputMaybe<PostLinkedInArgs>;
  links?: InputMaybe<Array<PostLinkArgs>>;
  medias?: InputMaybe<Array<PostMediaArgs>>;
  netProfileAuthIds: Array<Scalars['String']['input']>;
  publishAt?: InputMaybe<Scalars['DateTime']['input']>;
  reviewersIds?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduleType: PostScheduleType;
  threads?: InputMaybe<PostThreadsArgs>;
  tiktok?: InputMaybe<PostTiktokArgs>;
  twitter?: InputMaybe<PostTwitterArgs>;
  type: PostType;
  youtube?: InputMaybe<PostYoutubeArgs>;
};


export type MutationCreatePostsViewArgs = {
  groupBy?: InputMaybe<PostGroupBy>;
  labelIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  reviewerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  stages?: InputMaybe<Array<PostStage>>;
  types?: InputMaybe<Array<PostType>>;
  viewType: PostsViewType;
};


export type MutationCreatePostsViewShareTokenArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAccountArgs = {
  password: Scalars['String']['input'];
};


export type MutationDeleteAndieChatThreadArgs = {
  threadId: Scalars['String']['input'];
};


export type MutationDeleteCompetitorsArgs = {
  competitors: Array<DashProfileArgs>;
};


export type MutationDeleteDashArgs = {
  dashesIds: Array<Scalars['String']['input']>;
};


export type MutationDeleteDashWidgetArgs = {
  dashId: Scalars['String']['input'];
  widgetId: Scalars['String']['input'];
};


export type MutationDeleteGroupArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteMediaLibArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePostArgs = {
  postId: Scalars['String']['input'];
};


export type MutationDeletePostMessageArgs = {
  postMessageId: Scalars['String']['input'];
};


export type MutationDeletePostsViewArgs = {
  id: Scalars['String']['input'];
};


export type MutationDownloadInvoiceArgs = {
  docNumber: Scalars['String']['input'];
};


export type MutationDuplicateDashArgs = {
  dashId: Scalars['String']['input'];
};


export type MutationDuplicatePostArgs = {
  postId: Scalars['String']['input'];
};


export type MutationDuplicateWidgetArgs = {
  dashId: Scalars['String']['input'];
  widgetId: Scalars['String']['input'];
};


export type MutationEditDashArgs = {
  brandName?: InputMaybe<Scalars['String']['input']>;
  brandPicture?: InputMaybe<Scalars['String']['input']>;
  categoriesIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dashId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  profiles: Array<DashProfileArgs>;
  scheduleDeliveryEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduleExportType?: InputMaybe<ExportReqType>;
  scheduleFrequency?: InputMaybe<ScheduleFrequency>;
  scheduleMonthlyDay?: InputMaybe<Scalars['Int']['input']>;
  scheduleTime?: InputMaybe<Scalars['String']['input']>;
  scheduleWeekDay?: InputMaybe<ScheduleWeekDay>;
  themeId: Scalars['String']['input'];
};


export type MutationEditDashViewTypeArgs = {
  dashId: Scalars['String']['input'];
  viewType: DashViewType;
};


export type MutationEditDashWidgetsPositionArgs = {
  dashId: Scalars['String']['input'];
  widgetPositions: Array<WidgetPositionArgs>;
};


export type MutationEditInsightWidgetArgs = {
  dashId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  filterMetricId?: InputMaybe<Scalars['String']['input']>;
  filterText?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  periodId?: InputMaybe<Scalars['String']['input']>;
  profiles: Array<DashProfileArgs>;
  rowCount?: Scalars['Int']['input'];
  sortAsc?: InputMaybe<Scalars['Boolean']['input']>;
  sortMetricId?: InputMaybe<Scalars['String']['input']>;
  widgetMetrics: Array<WidgetMetricInput>;
  widgetTypeId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditNoteWidgetTextArgs = {
  dashId: Scalars['String']['input'];
  text: Scalars['String']['input'];
  widgetId: Scalars['String']['input'];
};


export type MutationEditPostMessageArgs = {
  body: Scalars['String']['input'];
  postMessageId: Scalars['String']['input'];
  richText?: InputMaybe<Scalars['String']['input']>;
};


export type MutationExportDashCsvArgs = {
  dashId: Scalars['String']['input'];
};


export type MutationExportDashPdfArgs = {
  dashId: Scalars['String']['input'];
};


export type MutationGuestApprovePostArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  postId: Scalars['String']['input'];
};


export type MutationGuestDeletePostMessageArgs = {
  postMessageId: Scalars['String']['input'];
};


export type MutationGuestEditPostMessageArgs = {
  body: Scalars['String']['input'];
  postMessageId: Scalars['String']['input'];
  richText?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGuestRequestPostRevisionArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  postId: Scalars['String']['input'];
};


export type MutationGuestSendPostMessageArgs = {
  attachmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  body: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  replyToId?: InputMaybe<Scalars['String']['input']>;
  richText?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGuestTogglePostMessageReactionArgs = {
  emoji: Scalars['String']['input'];
  postMessageId: Scalars['String']['input'];
};


export type MutationInviteWorkspaceGuestArgs = {
  area: GuestArea;
  email: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMoveOnboardingToPostArgs = {
  id: Scalars['String']['input'];
  netProfileAuthId: Scalars['String']['input'];
};


export type MutationReadAllNotificationsArgs = {
  tab?: NotificationTab;
};


export type MutationReadNotificationArgs = {
  group?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRejectPostArgs = {
  postId: Scalars['String']['input'];
};


export type MutationRemoveMediaLibPreviewArgs = {
  mediaLibId: Scalars['String']['input'];
};


export type MutationRemoveOverQuotaItemsArgs = {
  input: Array<OverQuotaDeletionInput>;
};


export type MutationRequestUserChangeEmailArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationResendWorkspaceGuestInviteArgs = {
  id: Scalars['String']['input'];
};


export type MutationRevokeWorkspaceGuestArgs = {
  id: Scalars['String']['input'];
};


export type MutationRotateApiClientArgs = {
  keySlot: ApiClientKeySlot;
  password: Scalars['String']['input'];
};


export type MutationSaveDashFiltersArgs = {
  compareToId?: InputMaybe<Scalars['String']['input']>;
  dashId: Scalars['String']['input'];
  filterLabelsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  periodId?: InputMaybe<Scalars['String']['input']>;
  profiles?: InputMaybe<Array<DashProfileArgs>>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationSchedulePostArgs = {
  postId: Scalars['String']['input'];
  publishNow?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSendPostMessageArgs = {
  attachmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  body: Scalars['String']['input'];
  channel: PostMessageChannel;
  postId: Scalars['String']['input'];
  replyToId?: InputMaybe<Scalars['String']['input']>;
  richText?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendPostToClientReviewArgs = {
  postId: Scalars['String']['input'];
};


export type MutationSetGroupProfilesArgs = {
  groupId: Scalars['String']['input'];
  profileAuthIds: Array<Scalars['String']['input']>;
};


export type MutationSetUserNotificationChannelArgs = {
  channel: NotificationChannel;
  code: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
};


export type MutationSubscribeArgs = {
  couponRef?: InputMaybe<Scalars['String']['input']>;
  priceRef: Scalars['String']['input'];
  referral?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSwitchWorkspaceArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  idLegacy?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationTeamReviewPostArgs = {
  postId: Scalars['String']['input'];
};


export type MutationToggleDashShareTokenArgs = {
  dashId: Scalars['String']['input'];
};


export type MutationToggleFavoriteDashArgs = {
  dashesIds: Array<Scalars['String']['input']>;
};


export type MutationToggleFavoriteWidgetArgs = {
  widgetsIds: Array<Scalars['String']['input']>;
};


export type MutationTogglePinPostsViewArgs = {
  postsViewId: Scalars['String']['input'];
};


export type MutationTogglePostMessageReactionArgs = {
  emoji: Scalars['String']['input'];
  postMessageId: Scalars['String']['input'];
};


export type MutationTogglePostsViewShareTokenArgs = {
  id: Scalars['String']['input'];
};


export type MutationUnclearNotificationArgs = {
  group?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnreadNotificationArgs = {
  group?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnschedulePostArgs = {
  postId: Scalars['String']['input'];
};


export type MutationUpdateAccountTimezoneArgs = {
  timezoneId: Scalars['String']['input'];
};


export type MutationUpdateAndieChatThreadTitleArgs = {
  threadId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


export type MutationUpdateBillingEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateGroupArgs = {
  color?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateInvoicingInfoArgs = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  countryId: Scalars['String']['input'];
  isPerson?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  vat: Scalars['String']['input'];
};


export type MutationUpdateLanguageArgs = {
  languageId: Scalars['String']['input'];
};


export type MutationUpdatePostArgs = {
  briefing?: InputMaybe<PostBriefingArgs>;
  captions?: InputMaybe<Array<PostCaptionArgs>>;
  facebook?: InputMaybe<PostFacebookArgs>;
  googleMyBusiness?: InputMaybe<PostGoogleMyBusinessArgs>;
  instagram?: InputMaybe<PostInstagramArgs>;
  instagramV2?: InputMaybe<PostInstagramV2Args>;
  labelsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  linkedIn?: InputMaybe<PostLinkedInArgs>;
  links?: InputMaybe<Array<PostLinkArgs>>;
  medias?: InputMaybe<Array<PostMediaArgs>>;
  netProfileAuthIds?: InputMaybe<Array<Scalars['String']['input']>>;
  postId: Scalars['String']['input'];
  publishAt?: InputMaybe<Scalars['DateTime']['input']>;
  reviewersIds?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduleType?: InputMaybe<PostScheduleType>;
  threads?: InputMaybe<PostThreadsArgs>;
  tiktok?: InputMaybe<PostTiktokArgs>;
  twitter?: InputMaybe<PostTwitterArgs>;
  type?: InputMaybe<PostType>;
  youtube?: InputMaybe<PostYoutubeArgs>;
};


export type MutationUpdatePostsViewArgs = {
  groupBy?: InputMaybe<PostGroupBy>;
  id: Scalars['String']['input'];
  labelIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  reviewerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  stages?: InputMaybe<Array<PostStage>>;
  types?: InputMaybe<Array<PostType>>;
  viewType?: InputMaybe<PostsViewType>;
};


export type MutationUpdateUserInfoArgs = {
  name: Scalars['String']['input'];
};


export type MutationUpdateUserPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type MutationUpdateUserPictureArgs = {
  filename: Scalars['String']['input'];
};


export type MutationUpdateWorkspaceInfoArgs = {
  name: Scalars['String']['input'];
};


export type MutationUpdateWorkspaceLanguageArgs = {
  languageId: Scalars['String']['input'];
};


export type MutationUpdateWorkspacePictureArgs = {
  filename: Scalars['String']['input'];
};


export type MutationUpdateWorkspaceSettingsArgs = {
  autoUtmContentDefault: Scalars['Boolean']['input'];
  skipBypassableInstagramPublishErrors: Scalars['Boolean']['input'];
};


export type MutationUpdateWorkspaceTimezoneArgs = {
  timezoneId: Scalars['String']['input'];
};


export type MutationUserResourceDismissDismissArgs = {
  resource: UserResourceDismissResource;
};


export type MutationUserResourceDismissRevertDismissArgs = {
  resource: UserResourceDismissResource;
};

export type Net = {
  __typename?: 'Net';
  code: NetCode;
  color: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status?: Maybe<NetStatus>;
};

export enum NetCode {
  Blogger = 'BLOGGER',
  Facebook = 'FACEBOOK',
  GoogleMyBusiness = 'GOOGLE_MY_BUSINESS',
  Instagram = 'INSTAGRAM',
  InstagramV2 = 'INSTAGRAM_V2',
  Linkedin = 'LINKEDIN',
  MetaAds = 'META_ADS',
  Pinterest = 'PINTEREST',
  Threads = 'THREADS',
  Tiktok = 'TIKTOK',
  Tumblr = 'TUMBLR',
  Twitter = 'TWITTER',
  Wordpress = 'WORDPRESS',
  WordpressOrg = 'WORDPRESS_ORG',
  Youtube = 'YOUTUBE'
}

export type NetLocation = {
  __typename?: 'NetLocation';
  address?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type NetProfile = {
  __typename?: 'NetProfile';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  net: Net;
  picture?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type NetProfileAuth = {
  __typename?: 'NetProfileAuth';
  groups?: Maybe<Array<Group>>;
  id: Scalars['String']['output'];
  netProfile: NetProfile;
  statusLevel: NetProfileAuthStatusLevel;
  tokenStatus: NetProfileAuthTokenStatus;
  utms?: Maybe<NetProfileAuthUtms>;
};

export enum NetProfileAuthConnectResult {
  Added = 'ADDED',
  None = 'NONE',
  Refreshed = 'REFRESHED'
}

export type NetProfileAuthStatusCount = {
  __typename?: 'NetProfileAuthStatusCount';
  statusLevels: Array<StatusCount>;
};

export enum NetProfileAuthStatusLevel {
  Error = 'ERROR',
  Ok = 'OK',
  Warning = 'WARNING'
}

export enum NetProfileAuthTokenStatus {
  AppError = 'APP_ERROR',
  LimitReached = 'LIMIT_REACHED',
  NetProfileError = 'NET_PROFILE_ERROR',
  Ok = 'OK',
  PostInvalidData = 'POST_INVALID_DATA',
  SocialError = 'SOCIAL_ERROR',
  UserBlocked = 'USER_BLOCKED',
  UserError = 'USER_ERROR',
  UserInsufficientPermissionsError = 'USER_INSUFFICIENT_PERMISSIONS_ERROR',
  UserPermissionsError = 'USER_PERMISSIONS_ERROR'
}

export type NetProfileAuthUtms = {
  __typename?: 'NetProfileAuthUtms';
  campaign?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  term?: Maybe<Scalars['String']['output']>;
  trackingEnabled: Scalars['Boolean']['output'];
};

export enum NetStatus {
  Active = 'ACTIVE',
  ComingSoon = 'COMING_SOON',
  CurrentlyUnavailable = 'CURRENTLY_UNAVAILABLE',
  Discontinued = 'DISCONTINUED'
}

export type Notification = {
  __typename?: 'Notification';
  single?: Maybe<SingleNotification>;
  stacked?: Maybe<StackedNotification>;
};

export enum NotificationArea {
  AdsAnalytics = 'ADS_ANALYTICS',
  Analytics = 'ANALYTICS',
  Calendar = 'CALENDAR',
  CompetitorsAlerts = 'COMPETITORS_ALERTS',
  CompetitorAnalytics = 'COMPETITOR_ANALYTICS',
  Drafts = 'DRAFTS',
  Feed = 'FEED',
  General = 'GENERAL',
  Inbox = 'INBOX',
  Influencer = 'INFLUENCER',
  ProduceContent = 'PRODUCE_CONTENT',
  Profiles = 'PROFILES',
  Rss = 'RSS',
  TeamManagement = 'TEAM_MANAGEMENT',
  TeamWorkflow = 'TEAM_WORKFLOW'
}

export enum NotificationButton {
  InstantDownload = 'INSTANT_DOWNLOAD',
  MultiRedirect = 'MULTI_REDIRECT',
  Redirect = 'REDIRECT'
}

export enum NotificationChannel {
  Email = 'EMAIL'
}

export enum NotificationTab {
  All = 'ALL',
  Cleared = 'CLEARED',
  Warning = 'WARNING'
}

export enum NotificationVariant {
  Error = 'ERROR',
  General = 'GENERAL',
  Info = 'INFO',
  Success = 'SUCCESS',
  User = 'USER',
  Warning = 'WARNING'
}

export type Onboarding = {
  __typename?: 'Onboarding';
  createdAt: Scalars['DateTime']['output'];
  createdPosts: Array<Post>;
  id: Scalars['String']['output'];
  netProfile?: Maybe<NetProfile>;
  netProfileId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type OverQuotaDeletionInput = {
  ids: Array<Scalars['String']['input']>;
  key: PlanLimit;
};

export type OverQuotaItem = {
  __typename?: 'OverQuotaItem';
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  networkCode?: Maybe<Scalars['String']['output']>;
  subLabel?: Maybe<Scalars['String']['output']>;
};

export type OverQuotaResource = {
  __typename?: 'OverQuotaResource';
  current: Scalars['Int']['output'];
  items: Array<OverQuotaItem>;
  key: PlanLimit;
  limit: Scalars['Int']['output'];
  removable: Scalars['Boolean']['output'];
};

export type PaginatedCompareTos = {
  __typename?: 'PaginatedCompareTos';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<CompareTo>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedDashSourceProfiles = {
  __typename?: 'PaginatedDashSourceProfiles';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<DashSourceProfile>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedDashs = {
  __typename?: 'PaginatedDashs';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Dash>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedGroup = {
  __typename?: 'PaginatedGroup';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Group>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedGroupNotifications = {
  __typename?: 'PaginatedGroupNotifications';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<SingleNotification>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedInsightsCategories = {
  __typename?: 'PaginatedInsightsCategories';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<InsightsCategory>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedInvoice = {
  __typename?: 'PaginatedInvoice';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Invoice>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedLabels = {
  __typename?: 'PaginatedLabels';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Label>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedMetrics = {
  __typename?: 'PaginatedMetrics';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Metric>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedNetProfileAuth = {
  __typename?: 'PaginatedNetProfileAuth';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<NetProfileAuth>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedNotifications = {
  __typename?: 'PaginatedNotifications';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Notification>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedPeriods = {
  __typename?: 'PaginatedPeriods';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Period>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedPostsView = {
  __typename?: 'PaginatedPostsView';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<PostsView>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedThemes = {
  __typename?: 'PaginatedThemes';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Theme>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedWidgetTypes = {
  __typename?: 'PaginatedWidgetTypes';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<WidgetType>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedWidgets = {
  __typename?: 'PaginatedWidgets';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Widget>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedWorkspaceGuest = {
  __typename?: 'PaginatedWorkspaceGuest';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<WorkspaceGuest>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PaymentDefaultMethod = {
  __typename?: 'PaymentDefaultMethod';
  card?: Maybe<PaymentMethodCard>;
  paymentMethod: PaymentMethod;
  paypal?: Maybe<PaymentMethodPaypal>;
};

export enum PaymentMethod {
  Card = 'CARD',
  Other = 'OTHER',
  Paypal = 'PAYPAL'
}

export type PaymentMethodCard = {
  __typename?: 'PaymentMethodCard';
  brand: Scalars['String']['output'];
  expiration: Scalars['String']['output'];
  expired: Scalars['Boolean']['output'];
  last4: Scalars['String']['output'];
};

export type PaymentMethodPaypal = {
  __typename?: 'PaymentMethodPaypal';
  email: Scalars['String']['output'];
};

export type Period = {
  __typename?: 'Period';
  code: PeriodCode;
  id: Scalars['String']['output'];
  nameKey: Scalars['String']['output'];
};

export enum PeriodCode {
  Last_7Days = 'LAST_7_DAYS',
  Last_28Days = 'LAST_28_DAYS',
  LastMonth = 'LAST_MONTH',
  LastWeek = 'LAST_WEEK',
  YearToDate = 'YEAR_TO_DATE'
}

export type Permission = {
  __typename?: 'Permission';
  code: PermissionCode;
  descriptionKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  increments: Scalars['Int']['output'];
  max?: Maybe<Scalars['Int']['output']>;
  nameKey: Scalars['String']['output'];
  type: PermissionType;
};

export enum PermissionCode {
  AndieCredits = 'ANDIE_CREDITS',
  ApiRequestsPerMonth = 'API_REQUESTS_PER_MONTH',
  ApprovalWorkflow = 'APPROVAL_WORKFLOW',
  Competitors = 'COMPETITORS',
  Dashboards = 'DASHBOARDS',
  DashboardsExports = 'DASHBOARDS_EXPORTS',
  DashboardsSendSchedule = 'DASHBOARDS_SEND_SCHEDULE',
  DashboardsSendScheduleDaily = 'DASHBOARDS_SEND_SCHEDULE_DAILY',
  DashboardsSendScheduleFortnightly = 'DASHBOARDS_SEND_SCHEDULE_FORTNIGHTLY',
  DashboardsSendScheduleMonthly = 'DASHBOARDS_SEND_SCHEDULE_MONTHLY',
  DashboardsSendScheduleWeekly = 'DASHBOARDS_SEND_SCHEDULE_WEEKLY',
  DataHistory = 'DATA_HISTORY',
  DataHistory_1Month = 'DATA_HISTORY_1_MONTH',
  DataHistory_6Months = 'DATA_HISTORY_6_MONTHS',
  DataHistory_12Months = 'DATA_HISTORY_12_MONTHS',
  DataHistory_24Months = 'DATA_HISTORY_24_MONTHS',
  FeedConnector = 'FEED_CONNECTOR',
  FeedConnectorAutoPublish = 'FEED_CONNECTOR_AUTO_PUBLISH',
  FeedConnectorUpdateRate = 'FEED_CONNECTOR_UPDATE_RATE',
  FeedConnectorUpdateRate_1Hour = 'FEED_CONNECTOR_UPDATE_RATE_1_HOUR',
  FeedConnectorUpdateRate_5Minutes = 'FEED_CONNECTOR_UPDATE_RATE_5_MINUTES',
  FeedConnectorUpdateRate_6Hours = 'FEED_CONNECTOR_UPDATE_RATE_6_HOURS',
  FeedConnectorUpdateRate_12Hours = 'FEED_CONNECTOR_UPDATE_RATE_12_HOURS',
  FeedConnectorUpdateRateDaily = 'FEED_CONNECTOR_UPDATE_RATE_DAILY',
  McpToolsPerMonth = 'MCP_TOOLS_PER_MONTH',
  MonthlyPosts = 'MONTHLY_POSTS',
  PostsSchedule = 'POSTS_SCHEDULE',
  PostsSchedule_1Month = 'POSTS_SCHEDULE_1_MONTH',
  PostsSchedule_1Year = 'POSTS_SCHEDULE_1_YEAR',
  PostsSchedule_2Years = 'POSTS_SCHEDULE_2_YEARS',
  PostsSchedule_6Months = 'POSTS_SCHEDULE_6_MONTHS',
  Profiles = 'PROFILES',
  ProfilesGroups = 'PROFILES_GROUPS',
  SocialListeningSources = 'SOCIAL_LISTENING_SOURCES',
  SocialListeningUpdateRate = 'SOCIAL_LISTENING_UPDATE_RATE',
  SocialListeningUpdateRate_1Hour = 'SOCIAL_LISTENING_UPDATE_RATE_1_HOUR',
  SocialListeningUpdateRate_6Hours = 'SOCIAL_LISTENING_UPDATE_RATE_6_HOURS',
  SocialListeningUpdateRate_15Minutes = 'SOCIAL_LISTENING_UPDATE_RATE_15_MINUTES',
  SocialListeningUpdateRate_24Hours = 'SOCIAL_LISTENING_UPDATE_RATE_24_HOURS',
  UploadSizeImages = 'UPLOAD_SIZE_IMAGES',
  UploadSizeImages_5Mb = 'UPLOAD_SIZE_IMAGES_5MB',
  UploadSizeImages_25Mb = 'UPLOAD_SIZE_IMAGES_25MB',
  UploadSizeImages_50Mb = 'UPLOAD_SIZE_IMAGES_50MB',
  UploadSizeVideos = 'UPLOAD_SIZE_VIDEOS',
  UploadSizeVideos_2Gb = 'UPLOAD_SIZE_VIDEOS_2GB',
  UploadSizeVideos_100Mb = 'UPLOAD_SIZE_VIDEOS_100MB',
  UploadSizeVideos_500Mb = 'UPLOAD_SIZE_VIDEOS_500MB',
  WorkspaceMembers = 'WORKSPACE_MEMBERS',
  XCredits = 'X_CREDITS'
}

export type PermissionGroupItem = {
  __typename?: 'PermissionGroupItem';
  code: PermissionCode;
  descriptionKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  increments: Scalars['Int']['output'];
  max?: Maybe<Scalars['Int']['output']>;
  nameKey: Scalars['String']['output'];
  price?: Maybe<PermissionPrice>;
  type: PermissionType;
};

export type PermissionPrice = {
  __typename?: 'PermissionPrice';
  currency: Currency;
  flat?: Maybe<PermissionPriceFlat>;
  tier?: Maybe<Array<PermissionPriceTier>>;
};

export type PermissionPriceFlat = {
  __typename?: 'PermissionPriceFlat';
  monthlyPrice: Scalars['Float']['output'];
};

export type PermissionPriceTier = {
  __typename?: 'PermissionPriceTier';
  monthlyPrice: Scalars['Float']['output'];
  upTo?: Maybe<Scalars['Int']['output']>;
};

export type PermissionPricesList = {
  __typename?: 'PermissionPricesList';
  code: PermissionCode;
  dependOn?: Maybe<Permission>;
  descriptionKey: Scalars['String']['output'];
  enumPermission?: Maybe<Array<PermissionGroupItem>>;
  id: Scalars['String']['output'];
  increments: Scalars['Int']['output'];
  max?: Maybe<Scalars['Int']['output']>;
  nameKey: Scalars['String']['output'];
  price?: Maybe<PermissionPrice>;
  type: PermissionType;
};

export enum PermissionType {
  Boolean = 'BOOLEAN',
  Enum = 'ENUM',
  Numeric = 'NUMERIC'
}

export type Plan = {
  __typename?: 'Plan';
  id: Scalars['String']['output'];
  isTrial: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type PlanFeatureInput = {
  id: Scalars['String']['input'];
  value: Scalars['Int']['input'];
};

export enum PlanLimit {
  AndieCredits = 'ANDIE_CREDITS',
  CompetitorsProfiles = 'COMPETITORS_PROFILES',
  DashReportsLimit = 'DASH_REPORTS_LIMIT',
  DashSourceProfilesLimit = 'DASH_SOURCE_PROFILES_LIMIT',
  DashWidgetsLimit = 'DASH_WIDGETS_LIMIT',
  InsightsEmailScheduleLimit = 'INSIGHTS_EMAIL_SCHEDULE_LIMIT',
  InsightsHistoryLimit = 'INSIGHTS_HISTORY_LIMIT',
  InsightsHistoryLimitCompare = 'INSIGHTS_HISTORY_LIMIT_COMPARE',
  InsightsHistoryLimitRight = 'INSIGHTS_HISTORY_LIMIT_RIGHT',
  McpToolsLimit = 'MCP_TOOLS_LIMIT',
  PostPlanningDateLimit = 'POST_PLANNING_DATE_LIMIT',
  ProfilesGroups = 'PROFILES_GROUPS',
  PublicApiRequestsLimit = 'PUBLIC_API_REQUESTS_LIMIT',
  SocialProfiles = 'SOCIAL_PROFILES',
  TeamMembers = 'TEAM_MEMBERS',
  XCredits = 'X_CREDITS'
}

export enum PlanLimitType {
  Date = 'DATE',
  DateAfter = 'DATE_AFTER',
  DateBefore = 'DATE_BEFORE',
  Number = 'NUMBER'
}

export type PlanLimitsList = {
  __typename?: 'PlanLimitsList';
  current: Scalars['String']['output'];
  key: PlanLimit;
  limit: Scalars['String']['output'];
  type?: Maybe<PlanLimitType>;
};

export type PlanPermission = {
  __typename?: 'PlanPermission';
  permission: Permission;
  value: Scalars['Int']['output'];
};

export type PlanPreview = {
  __typename?: 'PlanPreview';
  code: Scalars['String']['output'];
  mostPopular: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  permissions: Array<PlanPermission>;
  plan: Plan;
  prices: Array<PlanPreviewPrice>;
};

export type PlanPreviewPrice = {
  __typename?: 'PlanPreviewPrice';
  currency: Currency;
  discount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  interval: PlanPriceInterval;
  isSubscribed: Scalars['Boolean']['output'];
  monthlyPrice: Scalars['Float']['output'];
};

export enum PlanPriceInterval {
  Day = 'day',
  Month = 'month',
  Week = 'week',
  Year = 'year'
}

export type Post = {
  __typename?: 'Post';
  accessLevel?: Maybe<PostAccessLevel>;
  bodies?: Maybe<Array<PostBody>>;
  briefing?: Maybe<PostBriefing>;
  budget?: Maybe<Scalars['Float']['output']>;
  budgetCurrency?: Maybe<Currency>;
  /** YYYY-MM-DD in the workspace timezone */
  day?: Maybe<Scalars['String']['output']>;
  errorOriginPostId?: Maybe<Scalars['String']['output']>;
  facebook?: Maybe<PostFacebook>;
  googleMyBusiness?: Maybe<PostGoogleMyBusiness>;
  id: Scalars['String']['output'];
  instagram?: Maybe<PostInstagram>;
  instagramV2?: Maybe<PostInstagramV2>;
  labels?: Maybe<Array<PostLabel>>;
  linkedIn?: Maybe<PostLinkedIn>;
  links?: Maybe<Array<PostLink>>;
  medias?: Maybe<Array<PostMedia>>;
  nets?: Maybe<Array<Net>>;
  previewMediaLib?: Maybe<MediaLib>;
  previewPostBody?: Maybe<PostBody>;
  profiles?: Maybe<Array<PostProfile>>;
  publishAt?: Maybe<Scalars['DateTime']['output']>;
  reviewers?: Maybe<Array<User>>;
  stage: PostStage;
  threads?: Maybe<PostThreads>;
  tiktok?: Maybe<PostTiktok>;
  twitter?: Maybe<PostTwitter>;
  type: PostType;
  youtube?: Maybe<PostYoutube>;
};

export enum PostAccessLevel {
  Full = 'FULL',
  Limited = 'LIMITED'
}

export type PostBody = {
  __typename?: 'PostBody';
  autoUtmContent?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  mentions?: Maybe<Array<PostBodyMention>>;
  netId?: Maybe<Scalars['String']['output']>;
  plainComment1st?: Maybe<Scalars['String']['output']>;
  plainText?: Maybe<Scalars['String']['output']>;
  richComment1st?: Maybe<Scalars['JSON']['output']>;
  richText?: Maybe<Scalars['JSON']['output']>;
};

export type PostBodyMention = {
  __typename?: 'PostBodyMention';
  id: Scalars['String']['output'];
  isComment1st: Scalars['Boolean']['output'];
  netId: Scalars['String']['output'];
  netProfile?: Maybe<NetProfile>;
  username: Scalars['String']['output'];
  usernameOverride?: Maybe<Scalars['String']['output']>;
};

export type PostBriefing = {
  __typename?: 'PostBriefing';
  markdown: Scalars['String']['output'];
  richText: Scalars['JSON']['output'];
};

export type PostBriefingArgs = {
  markdown: Scalars['String']['input'];
  richText: Scalars['JSON']['input'];
};

export type PostCaptionArgs = {
  autoUtmContent?: InputMaybe<Scalars['Boolean']['input']>;
  firstComment?: InputMaybe<FirstComment>;
  mentions?: InputMaybe<Array<PostMention>>;
  netId?: InputMaybe<Scalars['String']['input']>;
  plainText?: InputMaybe<Scalars['String']['input']>;
  richText?: InputMaybe<Scalars['JSON']['input']>;
};

export enum PostClientAudience {
  NoClients = 'NO_CLIENTS',
  NoMatchingView = 'NO_MATCHING_VIEW',
  Reachable = 'REACHABLE',
  ViewNotShared = 'VIEW_NOT_SHARED'
}

export type PostClientAudienceResult = {
  __typename?: 'PostClientAudienceResult';
  audience: PostClientAudience;
  views: Array<PostClientAudienceView>;
};

export type PostClientAudienceView = {
  __typename?: 'PostClientAudienceView';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  onlyPostProfiles: Scalars['Boolean']['output'];
};

export type PostFacebook = {
  __typename?: 'PostFacebook';
  carouselEndCard?: Maybe<Scalars['Boolean']['output']>;
  carousels?: Maybe<Array<PostFacebookCarousel>>;
  netLocation?: Maybe<NetLocation>;
};

export type PostFacebookArgs = {
  carouselEndCard?: InputMaybe<Scalars['Boolean']['input']>;
  carousels?: InputMaybe<Array<PostFacebookCarouselArgs>>;
  netLocationId?: InputMaybe<Scalars['String']['input']>;
};

export enum PostFacebookCallToAction {
  BookTravel = 'BOOK_TRAVEL',
  BuyNow = 'BUY_NOW',
  Download = 'DOWNLOAD',
  GetQuote = 'GET_QUOTE',
  InstallApp = 'INSTALL_APP',
  InstallMobileApp = 'INSTALL_MOBILE_APP',
  LearnMore = 'LEARN_MORE',
  LikePage = 'LIKE_PAGE',
  ListenMusic = 'LISTEN_MUSIC',
  MessagePage = 'MESSAGE_PAGE',
  NoButton = 'NO_BUTTON',
  OpenLink = 'OPEN_LINK',
  PlayGame = 'PLAY_GAME',
  ShopNow = 'SHOP_NOW',
  SignUp = 'SIGN_UP',
  Subscribe = 'SUBSCRIBE',
  UseApp = 'USE_APP',
  UseMobileApp = 'USE_MOBILE_APP',
  WatchMore = 'WATCH_MORE',
  WatchVideo = 'WATCH_VIDEO'
}

export type PostFacebookCarousel = {
  __typename?: 'PostFacebookCarousel';
  callToAction?: Maybe<PostFacebookCallToAction>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  link: Scalars['String']['output'];
  media?: Maybe<MediaLib>;
  title: Scalars['String']['output'];
};

export type PostFacebookCarouselArgs = {
  callToAction?: InputMaybe<PostFacebookCallToAction>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  link: Scalars['String']['input'];
  linkPicture?: InputMaybe<Scalars['String']['input']>;
  mediaLibId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export enum PostGmbCallToAction {
  Book = 'BOOK',
  Call = 'CALL',
  LearnMore = 'LEARN_MORE',
  Order = 'ORDER',
  Shop = 'SHOP',
  SignUp = 'SIGN_UP'
}

export enum PostGmbPostTopicType {
  Event = 'EVENT',
  Offer = 'OFFER',
  Standard = 'STANDARD'
}

export type PostGoogleMyBusiness = {
  __typename?: 'PostGoogleMyBusiness';
  couponCode?: Maybe<Scalars['String']['output']>;
  ctaLink?: Maybe<Scalars['String']['output']>;
  ctaType?: Maybe<PostGmbCallToAction>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  postTopicType: PostGmbPostTopicType;
  redeemOnlineUrl?: Maybe<Scalars['String']['output']>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  termConditions?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PostGoogleMyBusinessArgs = {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  ctaLink?: InputMaybe<Scalars['String']['input']>;
  ctaType?: InputMaybe<PostGmbCallToAction>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  postTopicType: PostGmbPostTopicType;
  redeemOnlineUrl?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  termConditions?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum PostGroupBy {
  Date = 'DATE',
  None = 'NONE',
  Stage = 'STAGE'
}

export type PostInstagram = {
  __typename?: 'PostInstagram';
  collaborators?: Maybe<Array<PostInstagramCollaborator>>;
  netLocation?: Maybe<NetLocation>;
  shareToFeed?: Maybe<Scalars['Boolean']['output']>;
};

export type PostInstagramArgs = {
  collaborators?: InputMaybe<Array<PostInstagramCollaboratorArgs>>;
  netLocationId?: InputMaybe<Scalars['String']['input']>;
  shareToFeed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PostInstagramCollaborator = {
  __typename?: 'PostInstagramCollaborator';
  netProfile?: Maybe<NetProfile>;
  usernameOverride?: Maybe<Scalars['String']['output']>;
};

export type PostInstagramCollaboratorArgs = {
  netProfileId?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type PostInstagramV2 = {
  __typename?: 'PostInstagramV2';
  collaborators?: Maybe<Array<PostInstagramV2Collaborator>>;
  shareToFeed?: Maybe<Scalars['Boolean']['output']>;
};

export type PostInstagramV2Args = {
  collaborators?: InputMaybe<Array<PostInstagramCollaboratorArgs>>;
  shareToFeed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PostInstagramV2Collaborator = {
  __typename?: 'PostInstagramV2Collaborator';
  netProfile?: Maybe<NetProfile>;
  usernameOverride?: Maybe<Scalars['String']['output']>;
};

export type PostLabel = {
  __typename?: 'PostLabel';
  label: Label;
};

export type PostLink = {
  __typename?: 'PostLink';
  id: Scalars['String']['output'];
  link: Scalars['String']['output'];
  linkDescription?: Maybe<Scalars['String']['output']>;
  linkTitle: Scalars['String']['output'];
  media?: Maybe<MediaLib>;
  netId?: Maybe<Scalars['String']['output']>;
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmContent?: Maybe<Scalars['String']['output']>;
  utmMedium?: Maybe<Scalars['String']['output']>;
  utmSource?: Maybe<Scalars['String']['output']>;
  utmTerm?: Maybe<Scalars['String']['output']>;
};

export type PostLinkArgs = {
  link: Scalars['String']['input'];
  linkDescription?: InputMaybe<Scalars['String']['input']>;
  linkPicture?: InputMaybe<Scalars['String']['input']>;
  linkTitle: Scalars['String']['input'];
  mediaLibId?: InputMaybe<Scalars['String']['input']>;
  netId?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
};

export type PostLinkedIn = {
  __typename?: 'PostLinkedIn';
  documentTitle?: Maybe<Scalars['String']['output']>;
};

export type PostLinkedInArgs = {
  documentTitle?: InputMaybe<Scalars['String']['input']>;
};

export type PostMedia = {
  __typename?: 'PostMedia';
  media: MediaLib;
  net?: Maybe<Net>;
};

export type PostMediaArgs = {
  mediaFiles: Array<PostMediaFilesArgs>;
  netId?: InputMaybe<Scalars['String']['input']>;
};

export type PostMediaFilesArgs = {
  mediaLibId: Scalars['String']['input'];
};

export type PostMention = {
  isComment1st: Scalars['Boolean']['input'];
  netId: Scalars['String']['input'];
  netProfileId?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
  usernameOverride?: InputMaybe<Scalars['String']['input']>;
};

export type PostMessage = {
  __typename?: 'PostMessage';
  attachments: Array<MediaLib>;
  author: PostMessageAuthor;
  body: Scalars['String']['output'];
  channel: PostMessageChannel;
  createdAt: Scalars['DateTime']['output'];
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  reactions: Array<PostMessageReactionGroup>;
  replyTo?: Maybe<PostMessage>;
  richText?: Maybe<Scalars['JSON']['output']>;
};

export type PostMessageAuthor = {
  __typename?: 'PostMessageAuthor';
  color?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isMine: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  type: PostMessageAuthorType;
};

export enum PostMessageAuthorType {
  Andie = 'ANDIE',
  ClientUser = 'CLIENT_USER',
  TeamUser = 'TEAM_USER'
}

export enum PostMessageChannel {
  Client = 'CLIENT',
  Internal = 'INTERNAL'
}

export type PostMessageReactionGroup = {
  __typename?: 'PostMessageReactionGroup';
  count: Scalars['Int']['output'];
  emoji: Scalars['String']['output'];
  reactedByMe: Scalars['Boolean']['output'];
  users: Array<Scalars['String']['output']>;
};

export type PostMessages = {
  __typename?: 'PostMessages';
  hasMore: Scalars['Boolean']['output'];
  items: Array<PostMessage>;
};

export type PostProfile = {
  __typename?: 'PostProfile';
  comment1stRawError?: Maybe<Scalars['JSON']['output']>;
  netProfileAuth?: Maybe<NetProfileAuth>;
  postUrl?: Maybe<Scalars['String']['output']>;
  publishStatus: PostPublishStatus;
  rawError?: Maybe<Scalars['JSON']['output']>;
  thumbnailRawError?: Maybe<Scalars['JSON']['output']>;
  userError?: Maybe<PostUserError>;
};

export enum PostPublishStatus {
  ErrorPublishing = 'ERROR_PUBLISHING',
  ErrorUploading = 'ERROR_UPLOADING',
  Pending = 'PENDING',
  Published = 'PUBLISHED',
  PublishedFailedComment_1St = 'PUBLISHED_FAILED_COMMENT_1ST',
  PublishedFailedThumbnail = 'PUBLISHED_FAILED_THUMBNAIL',
  Publishing = 'PUBLISHING',
  ReadyToPublish = 'READY_TO_PUBLISH',
  TimeLimitReached = 'TIME_LIMIT_REACHED',
  Uploading = 'UPLOADING'
}

export enum PostScheduleType {
  Immediately = 'IMMEDIATELY',
  Queue = 'QUEUE',
  Recurring = 'RECURRING',
  SpecificDates = 'SPECIFIC_DATES'
}

export enum PostStage {
  Archive = 'ARCHIVE',
  ClientApproved = 'CLIENT_APPROVED',
  ClientReview = 'CLIENT_REVIEW',
  ClientRevision = 'CLIENT_REVISION',
  Draft = 'DRAFT',
  Idea = 'IDEA',
  Published = 'PUBLISHED',
  PublishedFailed = 'PUBLISHED_FAILED',
  Scheduled = 'SCHEDULED',
  TeamApproved = 'TEAM_APPROVED',
  TeamReview = 'TEAM_REVIEW',
  TeamRevision = 'TEAM_REVISION'
}

export type PostThreads = {
  __typename?: 'PostThreads';
  isGhostPost?: Maybe<Scalars['Boolean']['output']>;
  netLocation?: Maybe<NetLocation>;
  poll?: Maybe<Array<Scalars['String']['output']>>;
};

export type PostThreadsArgs = {
  isGhostPost?: InputMaybe<Scalars['Boolean']['input']>;
  netLocationId?: InputMaybe<Scalars['String']['input']>;
  poll?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PostTiktok = {
  __typename?: 'PostTiktok';
  autoAddMusic: Scalars['Boolean']['output'];
  disableComments: Scalars['Boolean']['output'];
  disableDuet: Scalars['Boolean']['output'];
  disableStitch: Scalars['Boolean']['output'];
  isAiGenerated: Scalars['Boolean']['output'];
  isBrandOrganic: Scalars['Boolean']['output'];
  isBrandedContent: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type PostTiktokArgs = {
  autoAddMusic: Scalars['Boolean']['input'];
  disableComments: Scalars['Boolean']['input'];
  disableDuet: Scalars['Boolean']['input'];
  disableStitch: Scalars['Boolean']['input'];
  isAiGenerated: Scalars['Boolean']['input'];
  isBrandOrganic: Scalars['Boolean']['input'];
  isBrandedContent: Scalars['Boolean']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PostTwitter = {
  __typename?: 'PostTwitter';
  madeWithAi?: Maybe<Scalars['Boolean']['output']>;
  paidPartnership?: Maybe<Scalars['Boolean']['output']>;
  poll?: Maybe<Array<Scalars['String']['output']>>;
  pollDuration?: Maybe<Scalars['Int']['output']>;
  replySettings?: Maybe<PostTwitterReplySettings>;
  superFollowersOnly?: Maybe<Scalars['Boolean']['output']>;
};

export type PostTwitterArgs = {
  madeWithAi?: InputMaybe<Scalars['Boolean']['input']>;
  paidPartnership?: InputMaybe<Scalars['Boolean']['input']>;
  poll?: InputMaybe<Array<Scalars['String']['input']>>;
  pollDuration?: InputMaybe<Scalars['Int']['input']>;
  replySettings?: InputMaybe<PostTwitterReplySettings>;
  superFollowersOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PostTwitterReplySettings {
  Following = 'FOLLOWING',
  MentionedUsers = 'MENTIONED_USERS',
  Subscribers = 'SUBSCRIBERS',
  Verified = 'VERIFIED'
}

export enum PostType {
  Link = 'LINK',
  Media = 'MEDIA',
  Reel = 'REEL',
  Status = 'STATUS',
  Story = 'STORY'
}

export type PostUserError = {
  __typename?: 'PostUserError';
  action?: Maybe<PostUserErrorAction>;
  code: PostUserErrorCode;
  providerMessage?: Maybe<Scalars['String']['output']>;
  providerTitle?: Maybe<Scalars['String']['output']>;
  resolvableByUser: Scalars['Boolean']['output'];
};

export enum PostUserErrorAction {
  ContactSupport = 'CONTACT_SUPPORT',
  EditPost = 'EDIT_POST',
  ReconnectProfile = 'RECONNECT_PROFILE',
  Retry = 'RETRY'
}

export enum PostUserErrorCode {
  AccountBlocked = 'ACCOUNT_BLOCKED',
  AccountDisconnected = 'ACCOUNT_DISCONNECTED',
  InsufficientRole = 'INSUFFICIENT_ROLE',
  InternalError = 'INTERNAL_ERROR',
  InvalidPostContent = 'INVALID_POST_CONTENT',
  MissingPermissions = 'MISSING_PERMISSIONS',
  NetworkTemporary = 'NETWORK_TEMPORARY',
  ProfileError = 'PROFILE_ERROR',
  PublishFailed = 'PUBLISH_FAILED',
  RateLimited = 'RATE_LIMITED',
  XCreditsExhausted = 'X_CREDITS_EXHAUSTED'
}

export type PostYoutube = {
  __typename?: 'PostYoutube';
  containsSyntheticMedia: Scalars['Boolean']['output'];
  madeForKids: Scalars['Boolean']['output'];
  notifySubscribers: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type PostYoutubeArgs = {
  containsSyntheticMedia?: Scalars['Boolean']['input'];
  madeForKids?: Scalars['Boolean']['input'];
  notifySubscribers?: Scalars['Boolean']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Posts = {
  __typename?: 'Posts';
  budgets: Array<Budget>;
  items: Array<Post>;
  /** IANA name of the workspace timezone */
  timezone?: Maybe<Scalars['String']['output']>;
  totals: Array<Total>;
};

export type PostsFilters = {
  __typename?: 'PostsFilters';
  assignedTo?: Maybe<Array<User>>;
  groupBy?: Maybe<PostGroupBy>;
  labels?: Maybe<Array<Label>>;
  netProfilesAuth?: Maybe<Array<NetProfileAuth>>;
  search?: Maybe<Scalars['String']['output']>;
  stages?: Maybe<Array<PostStage>>;
  types?: Maybe<Array<PostType>>;
};

export type PostsPaginated = {
  __typename?: 'PostsPaginated';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Post>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PostsView = {
  __typename?: 'PostsView';
  canDelete: Scalars['Boolean']['output'];
  canEdit: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  groupBy?: Maybe<PostGroupBy>;
  id: Scalars['String']['output'];
  isPinned: Scalars['Boolean']['output'];
  labels?: Maybe<Array<Label>>;
  name: Scalars['String']['output'];
  profiles?: Maybe<Array<NetProfileAuth>>;
  query?: Maybe<Scalars['String']['output']>;
  reviewers?: Maybe<Array<User>>;
  stages: Array<PostStage>;
  types: Array<PostType>;
  updatedAt: Scalars['DateTime']['output'];
  viewType: PostsViewType;
  workspaceId: Scalars['String']['output'];
};

export enum PostsViewType {
  Calendar = 'CALENDAR',
  Kanban = 'KANBAN',
  List = 'LIST'
}

export type PreviewSpecs = {
  fileSizeBytes: Scalars['Int']['input'];
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export type Query = {
  __typename?: 'Query';
  andieChatMessages: AndieChatMessagesResponse;
  andieChatThreads: AndieChatThreadsResponse;
  andieUsage: AndieUsageStatus;
  compareTos: PaginatedCompareTos;
  countUnreadNotifications: Array<CountUnreadNotifications>;
  countries: Array<Country>;
  currentWorkspace: Workspace;
  dash: Dash;
  dashFilters: DashFilters;
  dashShareToken?: Maybe<AuthPublicToken>;
  dashSourceProfiles: PaginatedDashSourceProfiles;
  dashSources: Array<DashSource>;
  dashWidgets: Array<Widget>;
  dashboardData: DashboardData;
  dashboardGetStarted: DashboardGetStarted;
  dashs: PaginatedDashs;
  defaultPaymentMethod?: Maybe<PaymentDefaultMethod>;
  getApiClient?: Maybe<ApiClient>;
  groupNotifications: PaginatedGroupNotifications;
  groups: PaginatedGroup;
  guestPostMessage: PostMessage;
  guestPostMessages: PostMessages;
  hasActiveSubscription: Scalars['Boolean']['output'];
  hasEmailValidated: Scalars['Boolean']['output'];
  hasFailedPayment: Scalars['Boolean']['output'];
  hasInvoicingTaxesChanged: Scalars['Boolean']['output'];
  ideas: PostsPaginated;
  insightsCategories: PaginatedInsightsCategories;
  integrationUsage: IntegrationUsageStatus;
  invoices: PaginatedInvoice;
  invoicingInfo?: Maybe<InvoicingInfo>;
  labels: PaginatedLabels;
  languages: Array<Language>;
  me: User;
  mediaLib: MediaLib;
  metrics: PaginatedMetrics;
  netProfileAuth: NetProfileAuth;
  netProfileAuthConnectResult: NetProfileAuthConnectResult;
  netProfileAuths: PaginatedNetProfileAuth;
  nets: Array<Net>;
  notification: Notification;
  notifications: PaginatedNotifications;
  onboarding: Onboarding;
  overQuotaItems: Array<OverQuotaResource>;
  periods: PaginatedPeriods;
  planLimits: Array<PlanLimitsList>;
  planPermissionPrices: Array<PermissionPricesList>;
  plans: Array<PlanPreview>;
  post: Post;
  postActivity: Activities;
  postClientAudience: PostClientAudienceResult;
  postMentionableMembers: Array<User>;
  postMessage: PostMessage;
  postMessages: PostMessages;
  posts: Posts;
  postsByIds: Array<Post>;
  postsFilters: PostsFilters;
  postsView: PostsView;
  postsViewShareToken?: Maybe<AuthPublicToken>;
  postsViews: PaginatedPostsView;
  publicPostsView: PostsView;
  relatedPostsByErrorOrigin: Array<Post>;
  relatedPostsByRelatedTo: Array<Post>;
  scrapeLink?: Maybe<LinkScrape>;
  searchLocation: Array<NetLocation>;
  searchProfile: Array<NetProfile>;
  shareViewer: ShareViewer;
  statusLevelCount: NetProfileAuthStatusCount;
  subscriptionPreview?: Maybe<SubscriptionPreview>;
  teamPermissions: Array<TeamPermission>;
  teamPostReviewers: Array<User>;
  templateWidgets: PaginatedWidgets;
  themes: PaginatedThemes;
  timezones: Array<Timezone>;
  totalCompetitors: Scalars['Int']['output'];
  uploadUrls: Array<UploadUrl>;
  userNotificationChannels: Array<UserNotificationChannel>;
  userResourceDismiss?: Maybe<UserResourceDismiss>;
  userResourcesDismiss: Array<UserResourceDismiss>;
  widget?: Maybe<Widget>;
  widgetData: WidgetData;
  widgetTypes: PaginatedWidgetTypes;
  workspaceGuests: PaginatedWorkspaceGuest;
  workspaceMembers: Array<User>;
  workspaceOverQuota: Array<PlanLimitsList>;
  workspaceSettings: WorkspaceSettings;
  workspaces: WorkspacePaginated;
};


export type QueryAndieChatMessagesArgs = {
  threadId: Scalars['String']['input'];
};


export type QueryCompareTosArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDashArgs = {
  dashId: Scalars['String']['input'];
};


export type QueryDashFiltersArgs = {
  compareToId?: InputMaybe<Scalars['String']['input']>;
  dashId: Scalars['String']['input'];
  filterLabelsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  periodId?: InputMaybe<Scalars['String']['input']>;
  profiles?: InputMaybe<Array<DashProfileArgs>>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryDashShareTokenArgs = {
  dashId: Scalars['String']['input'];
};


export type QueryDashSourceProfilesArgs = {
  dashId?: InputMaybe<Scalars['String']['input']>;
  dashSourceGroup: DashSourceGroup;
  dashSourcesIds?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDashSourcesArgs = {
  group?: InputMaybe<DashSourceGroup>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryDashWidgetsArgs = {
  dashId: Scalars['String']['input'];
};


export type QueryDashsArgs = {
  categoriesIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dashsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  favoritesOnly?: Scalars['Boolean']['input'];
  orderBy?: InputMaybe<DashOrderBy>;
  popularOnly?: Scalars['Boolean']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sourcesIds?: InputMaybe<Array<Scalars['String']['input']>>;
  take?: InputMaybe<Scalars['Int']['input']>;
  type: DashListType;
};


export type QueryGroupNotificationsArgs = {
  group: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGroupsArgs = {
  includeEmpty?: Scalars['Boolean']['input'];
  onlyPublish?: Scalars['Boolean']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGuestPostMessageArgs = {
  id: Scalars['String']['input'];
};


export type QueryGuestPostMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  postId: Scalars['String']['input'];
  untilId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHasInvoicingTaxesChangedArgs = {
  countryId: Scalars['String']['input'];
  isPerson?: Scalars['Boolean']['input'];
  postalCode: Scalars['String']['input'];
};


export type QueryIdeasArgs = {
  assignedToIds?: InputMaybe<Array<Scalars['String']['input']>>;
  labelsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  netProfileAuthIds?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stages?: InputMaybe<Array<PostStage>>;
  take?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<PostType>>;
};


export type QueryInsightsCategoriesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInvoicesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLabelsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMediaLibArgs = {
  id: Scalars['String']['input'];
};


export type QueryMetricsArgs = {
  dashSourcesIds?: InputMaybe<Array<Scalars['String']['input']>>;
  onlyGeneric?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNetProfileAuthArgs = {
  id: Scalars['String']['input'];
};


export type QueryNetProfileAuthConnectResultArgs = {
  openedSecondsAgo: Scalars['Int']['input'];
};


export type QueryNetProfileAuthsArgs = {
  cache?: Scalars['Boolean']['input'];
  groupId?: InputMaybe<Scalars['String']['input']>;
  netId?: InputMaybe<Scalars['String']['input']>;
  onlyPublish?: Scalars['Boolean']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  statusLevels?: InputMaybe<Array<NetProfileAuthStatusLevel>>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNetsArgs = {
  onlyCompetitors?: Scalars['Boolean']['input'];
  onlyPublish?: Scalars['Boolean']['input'];
};


export type QueryNotificationArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotificationsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  tab?: NotificationTab;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOnboardingArgs = {
  id: Scalars['String']['input'];
};


export type QueryPeriodsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPlanLimitsArgs = {
  planLimits: Array<PlanLimit>;
};


export type QueryPostArgs = {
  postId: Scalars['String']['input'];
};


export type QueryPostActivityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  postId: Scalars['String']['input'];
};


export type QueryPostClientAudienceArgs = {
  postId: Scalars['String']['input'];
};


export type QueryPostMentionableMembersArgs = {
  channel: PostMessageChannel;
  postId: Scalars['String']['input'];
};


export type QueryPostMessageArgs = {
  id: Scalars['String']['input'];
};


export type QueryPostMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel: PostMessageChannel;
  limit?: InputMaybe<Scalars['Int']['input']>;
  postId: Scalars['String']['input'];
  untilId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPostsArgs = {
  assignedToIds?: InputMaybe<Array<Scalars['String']['input']>>;
  groupBy: PostGroupBy;
  labelsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  netProfileAuthIds?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stages?: InputMaybe<Array<PostStage>>;
  take?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<PostType>>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryPostsByIdsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryPostsFiltersArgs = {
  assignedToIds?: InputMaybe<Array<Scalars['String']['input']>>;
  groupBy?: InputMaybe<PostGroupBy>;
  labelsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  netProfileAuthIds?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  stages?: InputMaybe<Array<PostStage>>;
  types?: InputMaybe<Array<PostType>>;
};


export type QueryPostsViewArgs = {
  id: Scalars['String']['input'];
};


export type QueryPostsViewShareTokenArgs = {
  id: Scalars['String']['input'];
};


export type QueryPostsViewsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPublicPostsViewArgs = {
  id: Scalars['String']['input'];
};


export type QueryRelatedPostsByErrorOriginArgs = {
  errorOriginPostId?: InputMaybe<Scalars['String']['input']>;
  postId: Scalars['String']['input'];
};


export type QueryRelatedPostsByRelatedToArgs = {
  postId: Scalars['String']['input'];
};


export type QueryScrapeLinkArgs = {
  url: Scalars['String']['input'];
};


export type QuerySearchLocationArgs = {
  netId: Scalars['String']['input'];
  query: Scalars['String']['input'];
};


export type QuerySearchProfileArgs = {
  netId: Scalars['String']['input'];
  query: Scalars['String']['input'];
};


export type QueryStatusLevelCountArgs = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  netId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTeamPostReviewersArgs = {
  netProfileAuthIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryTemplateWidgetsArgs = {
  categoriesIds?: InputMaybe<Array<Scalars['String']['input']>>;
  favoritesOnly?: Scalars['Boolean']['input'];
  onlyGeneric?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<WidgetTemplatesOrderBy>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sourcesIds?: InputMaybe<Array<Scalars['String']['input']>>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryThemesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUploadUrlsArgs = {
  filenames: Array<Scalars['String']['input']>;
};


export type QueryUserResourceDismissArgs = {
  resource: UserResourceDismissResource;
};


export type QueryWidgetArgs = {
  widgetId: Scalars['String']['input'];
};


export type QueryWidgetDataArgs = {
  dashId?: InputMaybe<Scalars['String']['input']>;
  demoData?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<WidgetDataFilterArgs>;
  formula?: InputMaybe<Scalars['String']['input']>;
  formulaName?: InputMaybe<Scalars['String']['input']>;
  formulaUnit?: InputMaybe<Scalars['String']['input']>;
  groupBy1: MetricGroupByKey;
  groupBy2: MetricGroupByKey;
  labelsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  metrics: Array<WidgetDataMetricArgs>;
  profiles: Array<WidgetDataProfileArgs>;
  since: Scalars['DateTime']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<WidgetDataSortArgs>;
  take?: InputMaybe<Scalars['Int']['input']>;
  until: Scalars['DateTime']['input'];
  widgetTypeId: Scalars['String']['input'];
};


export type QueryWidgetTypesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWorkspaceGuestsArgs = {
  area: GuestArea;
  itemId: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWorkspacesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export enum ScheduleFrequency {
  Daily = 'DAILY',
  Fortnightly = 'FORTNIGHTLY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export enum ScheduleWeekDay {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type ShareViewer = {
  __typename?: 'ShareViewer';
  guest?: Maybe<ShareViewerGuest>;
  kind: ShareViewerKind;
};

export type ShareViewerGuest = {
  __typename?: 'ShareViewerGuest';
  email: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export enum ShareViewerKind {
  Guest = 'GUEST',
  Public = 'PUBLIC'
}

export type SingleNotification = {
  __typename?: 'SingleNotification';
  actions?: Maybe<Array<SingleNotificationActions>>;
  count: Scalars['Int']['output'];
  date: Scalars['DateTime']['output'];
  group: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  isRead: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  variant: NotificationVariant;
};

export type SingleNotificationActions = {
  __typename?: 'SingleNotificationActions';
  data: Scalars['JSON']['output'];
  nameKey: Scalars['String']['output'];
  type: NotificationButton;
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Specs = {
  duration?: InputMaybe<Scalars['Float']['input']>;
  fileSizeBytes: Scalars['BigInt']['input'];
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export type StackedNotification = {
  __typename?: 'StackedNotification';
  area: NotificationArea;
  count: Scalars['Int']['output'];
  group: Scalars['Int']['output'];
  isRead: Scalars['Boolean']['output'];
  last2: Array<StackedNotificationLast2>;
  variant: NotificationVariant;
};

export type StackedNotificationLast2 = {
  __typename?: 'StackedNotificationLast2';
  count: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  isRead: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
};

export type StatusCount = {
  __typename?: 'StatusCount';
  count: Scalars['Int']['output'];
  statusLevel: NetProfileAuthStatusLevel;
};

export type Subscribe = {
  __typename?: 'Subscribe';
  redirectToSubscribe: Scalars['Boolean']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  andieChatStream: AndieChatChunk;
  andiePublicChatStream: AndieChatChunk;
};


export type SubscriptionAndieChatStreamArgs = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  chatId?: InputMaybe<Scalars['String']['input']>;
  messages: Scalars['JSON']['input'];
  mode?: InputMaybe<Scalars['String']['input']>;
  threadId?: InputMaybe<Scalars['String']['input']>;
  userLanguage?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionAndiePublicChatStreamArgs = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  chatId?: InputMaybe<Scalars['String']['input']>;
  messages: Scalars['JSON']['input'];
  mode?: InputMaybe<Scalars['String']['input']>;
  threadId?: InputMaybe<Scalars['String']['input']>;
  userLanguage?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionPreview = {
  __typename?: 'SubscriptionPreview';
  cancelAtPeriodEnd?: Maybe<Scalars['Boolean']['output']>;
  currency?: Maybe<Currency>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  interval?: Maybe<PlanPriceInterval>;
  intervalCount?: Maybe<Scalars['Int']['output']>;
  nextPaymentAmount?: Maybe<Scalars['Float']['output']>;
  plan: Plan;
  status: SubscriptionPreviewStatus;
};

export enum SubscriptionPreviewStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Expired = 'EXPIRED',
  Overdue = 'OVERDUE'
}

export enum TeamPermission {
  ApproveRejectPost = 'APPROVE_REJECT_POST',
  Billing = 'BILLING',
  CrudCompetitors = 'CRUD_COMPETITORS',
  ManageInsights = 'MANAGE_INSIGHTS',
  ManageWorkspaceSettings = 'MANAGE_WORKSPACE_SETTINGS',
  Owner = 'OWNER',
  PublishPost = 'PUBLISH_POST',
  ViewInsights = 'VIEW_INSIGHTS'
}

export type Theme = {
  __typename?: 'Theme';
  code: Scalars['String']['output'];
  id: Scalars['String']['output'];
  nameKey: Scalars['String']['output'];
};

export type Timezone = {
  __typename?: 'Timezone';
  id: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  timezoneKey: Scalars['String']['output'];
};

export type Total = {
  __typename?: 'Total';
  /** Date string with workspace timezone */
  day?: Maybe<Scalars['String']['output']>;
  /** YYYY-MM-DD in the workspace timezone */
  dayKey?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<PostStage>;
  value: Scalars['Int']['output'];
};

export type UploadUrl = {
  __typename?: 'UploadUrl';
  filename: Scalars['String']['output'];
  newFilename: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  color: Scalars['String']['output'];
  country?: Maybe<Country>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  language?: Maybe<Language>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  publicId: Scalars['Int']['output'];
  socketToken?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Timezone>;
};

export type UserNotificationChannel = {
  __typename?: 'UserNotificationChannel';
  channel: NotificationChannel;
  code: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
};

export type UserResourceDismiss = {
  __typename?: 'UserResourceDismiss';
  resource: UserResourceDismissResource;
};

export enum UserResourceDismissResource {
  DashDemo = 'DASH_DEMO',
  DashNeedHelp = 'DASH_NEED_HELP',
  DashSuggestedTemplates = 'DASH_SUGGESTED_TEMPLATES',
  Onboarding = 'ONBOARDING'
}

export type Widget = {
  __typename?: 'Widget';
  categories?: Maybe<Array<InsightsCategory>>;
  created?: Maybe<User>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  filterMetric?: Maybe<Metric>;
  filterText?: Maybe<Scalars['String']['output']>;
  formula?: Maybe<Scalars['String']['output']>;
  formulaName?: Maybe<Scalars['String']['output']>;
  formulaUnit?: Maybe<Scalars['String']['output']>;
  groupBy1: MetricGroupByKey;
  groupBy2: MetricGroupByKey;
  id: Scalars['String']['output'];
  isFavorite: Scalars['Boolean']['output'];
  metrics?: Maybe<Array<WidgetMetric>>;
  name: Scalars['String']['output'];
  period?: Maybe<Period>;
  position: Array<Scalars['Int']['output']>;
  profiles?: Maybe<Array<DashSourceProfile>>;
  rowCount?: Maybe<Scalars['Int']['output']>;
  since?: Maybe<Scalars['DateTime']['output']>;
  sortAsc?: Maybe<Scalars['Boolean']['output']>;
  sortMetric?: Maybe<Metric>;
  sources?: Maybe<Array<DashSource>>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<WidgetType>;
  until?: Maybe<Scalars['DateTime']['output']>;
};

export type WidgetData = {
  __typename?: 'WidgetData';
  alerts?: Maybe<Array<MetricAlert>>;
  error?: Maybe<WidgetDataError>;
  rowCount?: Maybe<Scalars['Int']['output']>;
  rows: Array<WidgetDataRow>;
};

export enum WidgetDataError {
  CollectingData = 'COLLECTING_DATA',
  EmptyState = 'EMPTY_STATE',
  MissingProfile = 'MISSING_PROFILE',
  WrongFilters = 'WRONG_FILTERS'
}

export type WidgetDataFilterArgs = {
  metricId: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type WidgetDataMetricArgs = {
  breakdownKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  letter: Scalars['String']['input'];
  metricId: Scalars['String']['input'];
};

export type WidgetDataProfileArgs = {
  dashSourceId: Scalars['String']['input'];
  profileId: Scalars['String']['input'];
};

export type WidgetDataRow = {
  __typename?: 'WidgetDataRow';
  key: Scalars['String']['output'];
  label: WidgetLabel;
  values: Array<WidgetDataRowValues>;
};

export type WidgetDataRowValues = {
  __typename?: 'WidgetDataRowValues';
  key: Scalars['String']['output'];
  label: WidgetLabel;
  str?: Maybe<Scalars['String']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type WidgetDataSortArgs = {
  metricId: Scalars['String']['input'];
  sortAsc: Scalars['Boolean']['input'];
};

export type WidgetLabel = {
  __typename?: 'WidgetLabel';
  breakdownKeys?: Maybe<Array<Scalars['String']['output']>>;
  date?: Maybe<Scalars['DateTime']['output']>;
  formula?: Maybe<Scalars['String']['output']>;
  letter?: Maybe<Scalars['String']['output']>;
  metric?: Maybe<Metric>;
  profile?: Maybe<DashSourceProfile>;
  str?: Maybe<Scalars['String']['output']>;
  type: MetricGroupByKey;
};

export type WidgetMetric = {
  __typename?: 'WidgetMetric';
  breakdownKeys: Array<Scalars['String']['output']>;
  letter: Scalars['String']['output'];
  metric: Metric;
};

export type WidgetMetricInput = {
  letter: Scalars['String']['input'];
  metricId: Scalars['String']['input'];
};

export type WidgetPositionArgs = {
  position: Array<Scalars['Int']['input']>;
  widgetId: Scalars['String']['input'];
};

export type WidgetTemplatesOrderBy = {
  field: WidgetTemplatesOrderByField;
  sort?: InputMaybe<SortOrder>;
};

export enum WidgetTemplatesOrderByField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME'
}

export type WidgetType = {
  __typename?: 'WidgetType';
  code: WidgetTypeCode;
  id: Scalars['String']['output'];
  maxHeight: Scalars['Int']['output'];
  maxWidth: Scalars['Int']['output'];
  minHeight: Scalars['Int']['output'];
  minWidth: Scalars['Int']['output'];
  nameKey: Scalars['String']['output'];
};

export enum WidgetTypeCode {
  Bars = 'BARS',
  BarsHorizontal = 'BARS_HORIZONTAL',
  BigNumber = 'BIG_NUMBER',
  Feed = 'FEED',
  Lines = 'LINES',
  Note = 'NOTE',
  Pie = 'PIE',
  Table = 'TABLE',
  WorldMap = 'WORLD_MAP'
}

export type Workspace = {
  __typename?: 'Workspace';
  billingEmail?: Maybe<Scalars['String']['output']>;
  color: Scalars['String']['output'];
  country?: Maybe<Country>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  isSwonkieDev: Scalars['Boolean']['output'];
  language: Language;
  name: Scalars['String']['output'];
  owner: User;
  picture?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<Plan>;
  publicId: Scalars['Int']['output'];
  timezone?: Maybe<Timezone>;
  totalMembers: Scalars['Int']['output'];
  useBrandPricing: Scalars['Boolean']['output'];
};

export type WorkspaceGuest = {
  __typename?: 'WorkspaceGuest';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  lastAccessAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status: GuestStatus;
};

export type WorkspaceGuestWithToken = {
  __typename?: 'WorkspaceGuestWithToken';
  guest: WorkspaceGuest;
  token: AuthPublicToken;
};

export type WorkspacePaginated = {
  __typename?: 'WorkspacePaginated';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Workspace>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type WorkspaceSettings = {
  __typename?: 'WorkspaceSettings';
  autoUtmContentDefault: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  skipBypassableInstagramPublishErrors: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['Int']['output']>;
  workspaceId: Scalars['Int']['output'];
};
